import { request } from '@/shared/api/request'

export const getChecksAll = (data, params) => {
	return request({ url: 'selftest/auth/page', method: 'POST', data: data, params: params })
}
